import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LabelService } from '../../services/label.service';
import {
  LabelAndSelected,
  PatientPharmacotherapy,
} from '../../models/patient-model';
import { PatientService } from '../../services/patient.service';

@Component({
  selector: 'app-panel-with-checkbox-list',
  standalone: false,
  templateUrl: './panel-with-checkbox-list.component.html',
  styleUrl: './panel-with-checkbox-list.component.scss',
})
export class PanelWithCheckboxListComponent {
  @Input() patientId: string = '';
  @Input() title: string = '';
  @Input() pharmacotherapyDescription: string = '';
  @Input() activePrinciplesList: LabelAndSelected[] = [];
  @Output() toggleActivePrinciples = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<string[]>();

  selectedActivePrinciples: string = '';
  selectedActivePrincipleBoolean: boolean = false;

  isBtnClicked: boolean = false;

  constructor(public labelService: LabelService) {}

  addRemoveActivePrinciples(principle: LabelAndSelected) {
    principle.selected = !principle.selected;
    this.activePrinciplesList.map((activePrinciple) => {
      if (activePrinciple.label === principle.label) {
        activePrinciple.selected = principle.selected;
      }
    });
  }

  confirmAction() {
    if (this.isBtnClicked) {
      return;
    }
    var selectedList = this.activePrinciplesList.filter(
      (activePrinciple) => activePrinciple.selected === true
    );

    selectedList.map((selected) => {
      this.selectedActivePrinciples =
        this.selectedActivePrinciples + selected.label + ',';
    });

    // remove last ,
    if (this.selectedActivePrinciples.length > 0) {
      this.selectedActivePrinciples = this.selectedActivePrinciples.slice(
        0,
        -1
      );
    }
    var returnArray: string[] = [
      this.selectedActivePrinciples,
      this.pharmacotherapyDescription,
    ];

    this.isBtnClicked = true;
    this.confirm.emit(returnArray);
  }

  toggleActivePrinciplesPanel() {
    this.toggleActivePrinciples.emit();
  }
}
